import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Signup() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const canceled = params.get("canceled") === "1";
  const plan = params.get("plan") === "annual" ? "annual" : "monthly";
  const priceLabel = plan === "annual" ? "$99 / year" : "$10 / month";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", {
        ...form,
        origin_url: window.location.origin,
        plan,
      });
      if (data.requires_payment) {
        // Stash session_id for verification on return
        localStorage.setItem("or_pending_session", data.session_id);
        window.location.href = data.checkout_url;
      } else {
        // Bypass user (owner/NFDA demo signing up)
        localStorage.setItem("or_token", data.token);
        toast.success("Account created.");
        nav("/dashboard");
      }
    } catch (err) {
      const msg = err?.response?.data?.detail || "Could not create account.";
      toast.error(msg);
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: "60px auto", padding: "0 24px" }}>
      <div className="bg-card" style={{ padding: 36 }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 12 }}>OBITUARY RELIEF</div>
          <h1 className="serif" style={{ fontSize: 32, color: "#fff", margin: "0 0 8px", fontWeight: 400 }}>Create your account</h1>
          <p className="muted" style={{ fontSize: 14 }}>{priceLabel}, auto-renewing. Cancel anytime.</p>
        </div>
        {canceled && (
          <div className="bg-card" style={{ padding: 14, marginBottom: 18, borderColor: "var(--border-gold)" }}>
            <div className="muted" style={{ fontSize: 13 }}>Payment was canceled. You can try again below.</div>
          </div>
        )}
        <form onSubmit={submit}>
          <label className="label-dark">Full name</label>
          <input data-testid="signup-name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="input-dark" style={{ marginBottom: 16 }} placeholder="Jane Doe" />
          <label className="label-dark">Email</label>
          <input data-testid="signup-email" required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="input-dark" style={{ marginBottom: 16 }} placeholder="you@email.com" />
          <label className="label-dark">Password</label>
          <input data-testid="signup-password" required type="password" minLength={6} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="input-dark" style={{ marginBottom: 24 }} placeholder="At least 6 characters" />
          <button data-testid="signup-submit" type="submit" disabled={loading} className="btn-gold" style={{ width: "100%", padding: "14px" }}>
            {loading ? "Redirecting to Stripe…" : "Continue to Payment →"}
          </button>
        </form>
        <div style={{ marginTop: 22, textAlign: "center", fontSize: 14 }} className="muted">
          Already have an account? <Link to="/login" data-testid="signup-link-login" className="link-gold">Log in</Link>
        </div>
      </div>
    </div>
  );
}
